
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';

import Heading from '../Heading/Heading';
import { DateFormat } from '../../lib/date';
import { ConfirmationWindow } from '../../lib/forms';
import { products, Auth } from '../../services'
class UnFreeze extends Component {
  constructor() {
    super();
    this.state = { data: "", freeze:"" };
  }
  componentDidMount(){
    const { rest, } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    products.getFreezes(ProductId)
    .then( res => {
      this.setState({
        freeze: res.body.data.productFreeze
      })
    }

    )
    products.getProduct(ProductId)
    .then(res => {
        this.setState({
          data: res.body.data.userProduct.Data
        })
      })
  }
  handleKeyPress = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
}
  render() {
    const { data, freeze } = this.state;
    const { translate, handleSubmit, cancel } = this.props;
    return (
      <div className="service-action">
        <div className="card card-service-active">
          <div className="card-block">
            {Heading(translate('unfreeze-request'),PhoneNumberFormat(data.phoneNumber))}
            <div className="card card-service-action">
              <div className="card-block">
            <form onSubmit={handleSubmit} onKeyPress={this.handleKeyPress}>
              <div className="form-group row">
                <div className="col">
                  <span className="display-block-span" >
                    {`${translate('information-product-frozen')} `}
                      <span className="font-weight-bold"><DateFormat className="font-weight-bold" date={freeze ? freeze.start : '' } /></span>
                      { freeze.end ? ` ${translate('to')} ` : ''}
                      <span className="font-weight-bold"><DateFormat date={freeze ? freeze.end: ''} />.</span>
                  </span>
                  <span className="display-block-span">
                    {` ${translate('are-you-sure-unblock')}`}
                  </span>
                </div>
              </div>

              <div className="form-group row">
                <div className="col text-right">
                  <button className="btn btn-secondary" type="button" onClick={ () => cancel() }>{translate('cancel')}</button>
                  <button className="btn btn-danger" type="button" data-target=".bd-example-modal-lg" data-toggle="modal"  >{translate('un-freeze-button')}</button>
                </div>
              </div>
              <ConfirmationWindow message={translate('un-freeze-the-line')} startDate={this.state.startDate} endDate={this.state.endDate} />
            </form>
          </div>
          </div>
        </div>
      </div>
    </div>
  )
  }
}

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    user: state.User.user,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  };
};

UnFreeze = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(UnFreeze);

 UnFreeze = reduxForm({
  form: 'Freeze',
  enableReinitialize: true,
})(UnFreeze)

class unFreezeFormHandler extends Component {

  handleSubmit(values) {
    const {  rest, translate, history, setFlashMessage } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    products.deleteFreeze(ProductId)
    .then(res => {
      setFlashMessage(`${translate('changes-saved-successfully')}`, true)
    })
    .catch((error) => {
      if (error.status === 401) {
        Auth.logOut();
      }
      console.log(error);
    });
    history.goBack();
   }
   cancel(values) {
     const { history } = this.props;
     history.goBack();
   }
  render() {
    return (
      <div>
        <UnFreeze onSubmit={this.handleSubmit.bind(this)} cancel={this.cancel.bind(this)} rest={this.props.rest}/>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    user: state.User.user,
    userID: state.User.id,

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  }
}

unFreezeFormHandler = connect(
  mapStateToProps,
  mapDispatchToProps
)(unFreezeFormHandler);
unFreezeFormHandler = withRouter(unFreezeFormHandler);
export default unFreezeFormHandler;



// WEBPACK FOOTER //
// ./src/components/Freeze/UnFreeze.js